import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-uploaded-dialog',
  templateUrl: './uploaded-dialog.component.html',
  styleUrls: ['./uploaded-dialog.component.css']
})
export class UploadedDialogComponent {

  constructor(private dialogRef: MatDialogRef<UploadedDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  copyToClipboard(val: string) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }

  refresh() {
    window.location.reload();
  }

  close() {
    window.close();
  }
}
